import { Injectable } from '@angular/core';
import { ISession } from '../../models/session-group/session.model';
import { IShopItem } from '../../models/shop-item/shop-item.model';
import { ISessionGroup } from '../../models/session-group/session-group.model';
import { ILocation } from '../../models/location/location.model';
import { ISessionLecturer } from '../../models/session-group/session-lecturer.model';
import { BehaviorSubject, finalize, of, take, tap } from 'rxjs';
import { ICallablesSessionsUpdateData, SessionsService } from '../entities/sessions/sessions.service';
import { ILecturer } from '../../models/user/lecturer/lecturer.model';
import { IUser } from '../../models/user/user.model';
import { ILocket } from '../../models/locket/locket.model';
import { SessionLecturersService } from '../entities/session-lecturers/session-lecturers.service';
import { ISessionLecturerCreateData, ISessionLecturerUpdateData } from '../../models/session-group/session-lecturer-change-data.model';
import { StoreService } from './store.service';

export interface ISessionCardData {
  session: ISession & { location: ILocation | null, sessionLecturers: (ISessionLecturer & { lecturer: ILecturer & { user: IUser & { lockets: ILocket[] } } } )[] };
  shopItem: IShopItem & { sessionGroup: ISessionGroup & { sessions: (ISession & { location: ILocation | null } )[] } };
  attendanceConflict: boolean;
  conflictedLecturers: {
    [lecturerId: number]: {
      lecturingWith: number[];
      warningEnabled: boolean;
    };
  };
}
export interface ISessionCardState {
  sessionData$: BehaviorSubject<ISessionCardData | null>;
  fetchingSessionData$: BehaviorSubject<boolean>;
  updatingSessionData$: BehaviorSubject<boolean>;
};

@Injectable({
  providedIn: 'root'
})
export class SessionCardStoreService {

  public state: ISessionCardState = {
    sessionData$: new BehaviorSubject<ISessionCardData | null>(null),
    fetchingSessionData$: new BehaviorSubject<boolean>(false),
    updatingSessionData$: new BehaviorSubject<boolean>(false),
  };

  constructor(
    private sessionsService: SessionsService,
    private sessionLecturersService: SessionLecturersService,
    private store: StoreService,
  ) { }

  public reset() {
    this.state.sessionData$.next(null);
  }

  public reinit() {
    const uuid = this.state.sessionData$.getValue()?.session.uuid;
    if (!uuid) return;
    this.init(uuid);
  }

  public init(uuid: string) {

    this.state.fetchingSessionData$.next(true);
    this.sessionsService.getDataForSessionCard({
      sessionUuid: uuid
    }).pipe(
      take(1),
      finalize(() => this.state.fetchingSessionData$.next(false))
    ).subscribe({
      next: (res) => {
        this.state.sessionData$.next(res);
      }
    });
  }

  public updateSession(data: ICallablesSessionsUpdateData) {
    this.state.updatingSessionData$.next(true);
    return this.sessionsService.updateSession(data).pipe(
      take(1),
      finalize(() => this.state.updatingSessionData$.next(false)),
      tap((updated) => {
        this.store.actions.sessionCard_sessionChanged$.next({ sessionId: updated.id });
        // this.reinit();
      })
    );
  }

  public updateSessionLecturer(data: ISessionLecturerUpdateData) {
    return this.sessionLecturersService.updateSessionLecturer(data).pipe(
      take(1),
      tap((updated) => {
        this.store.actions.sessionCard_sessionChanged$.next({ sessionId: updated.session.id });
        // this.reinit();
      })
    );
  }
  public createSessionLecturer(data: ISessionLecturerCreateData) {
    return this.sessionLecturersService.createSessionLecturer(data).pipe(
      take(1),
      tap((created) => {
        this.store.actions.sessionCard_sessionChanged$.next({ sessionId: created.sessionId });
        // this.reinit();

      })
    );
  }
  public deleteSessionLecturer(id: number) {
    const currState = this.state.sessionData$.getValue();
    if (!currState) return of();
    currState.session.sessionLecturers = <any>currState.session.sessionLecturers?.filter(x => x.id !== id)

    this.state.sessionData$.next(currState);

    return this.sessionLecturersService.deleteSessionLecturer(id).pipe(
      take(1),
      tap(() => {
        this.store.actions.sessionCard_sessionChanged$.next({ sessionId: currState.session.id });


      })
    );
  }
}
